import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock, ShoppingCart, RefreshCw, LogOut, ShieldCheck } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";

const FALLBACK_CHECKOUT = "https://lynk.id/scholavia/ne6kpwmkr1km";

export default function AccessRequired() {
  const { ready, user, entitled, checkoutUrl, displayName, logout } = useApp();
  const navigate = useNavigate();

  if (!ready) return <div className="flex min-h-screen items-center justify-center text-[#7C3AED]">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (entitled) return <Navigate to="/app" replace />;

  const checkout = checkoutUrl || FALLBACK_CHECKOUT;

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#FBFAFF] px-4 py-10">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_20%_15%,rgba(124,58,237,0.10),transparent_45%),radial-gradient(circle_at_85%_85%,rgba(124,58,237,0.08),transparent_45%)]" />
      <div className="relative w-full max-w-lg">
        <div className="mb-6 flex justify-center"><Logo /></div>

        <div className="rounded-3xl border border-purple-100 bg-white p-8 shadow-xl shadow-purple-100/50" data-testid="access-required-card">
          <div className="flex flex-col items-center text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#F3EEFF]">
              <Lock className="h-7 w-7 text-[#7C3AED]" />
            </span>
            <h1 className="mt-5 text-3xl font-bold tracking-tight text-slate-900" data-testid="access-required-title">Akses Belum Aktif</h1>
            <p className="mt-3 text-base text-slate-600">
              {displayName ? `Halo ${displayName}, ` : ""}akunmu sudah masuk, tetapi akses Scholavia belum aktif.
            </p>
            <p className="mt-2 text-sm text-slate-500">
              Silakan lakukan pembelian terlebih dahulu untuk mengaktifkan akses Scholavia. Akses akan aktif otomatis setelah pembayaran di Lynk.id berhasil.
            </p>
          </div>

          <a
            href={checkout} target="_blank" rel="noopener noreferrer" data-testid="beli-sekarang-btn"
            className="mt-7 flex w-full items-center justify-center gap-2 rounded-xl bg-[#7C3AED] py-4 text-base font-semibold text-white transition-colors hover:bg-[#6D28D9]"
          >
            <ShoppingCart className="h-5 w-5" /> Beli Sekarang
          </a>

          <button
            onClick={() => window.location.reload()} data-testid="cek-status-btn"
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl border border-purple-200 bg-white py-3 text-sm font-medium text-[#6D28D9] transition-colors hover:bg-[#FBFAFF]"
          >
            <RefreshCw className="h-4 w-4" /> Saya sudah bayar, cek status
          </button>

          <div className="mt-6 flex items-center justify-center gap-1.5 text-xs text-slate-400">
            <ShieldCheck className="h-3.5 w-3.5" /> Akses hanya aktif setelah pembayaran terverifikasi.
          </div>
        </div>

        <button
          onClick={handleLogout} data-testid="access-logout-btn"
          className="mx-auto mt-5 flex items-center justify-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-700"
        >
          <LogOut className="h-4 w-4" /> Keluar dari akun {user.email}
        </button>
      </div>
    </div>
  );
}
